import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';

import App, { registerServiceWorker } from 'setup';

function renderApp(AppComponent, appStore) {
  render(<AppComponent store={appStore} />, document.getElementById('root'));
}

renderApp(App);

if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept('./setup/index.js', () => {
    // eslint-disable-next-line global-require
    const NewApp = require('./setup/index.js').default;
    renderApp(NewApp);
  });
}

// killing the service worker if it exists. This will keep the app from working in offline mode and ignoring redirects!
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();

    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then(async (names) => {
        await Promise.all(names.map((name) => caches.delete(name)));
      });
    }
  });
}
